const actionTypes = {
    PROJECT : 'PROJECT'
};

export default actionTypes;